module.exports = __webpack_public_path__ + "static/media/call7.d6b465af.png";